import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.href ? `https://www.lemonnav.cn${item.href}` : 'https://www.lemonnav.cn',
        name: item.label,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}